import DbServerCore from "./serverImpl/dbServerCore";
import {DATABASE_ENUM, DB_SELECT} from "../config/db_config";
import DbFirebaseCore from "./firebaseImpl/dbFirebaseCore";
import DbInterface from "./dbInterface";

const dbCore: DbInterface =
    (DB_SELECT == DATABASE_ENUM.mongo) ? new DbServerCore() : new DbFirebaseCore();

export default dbCore;